<p-blockUI [blocked]="blocked">
    <div id="center">
      <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
    </div>
</p-blockUI>

<div class="grid m-0 mt-4 text-primary">
	<div class="col-12">
		<div class="m-0 grid flex-column">
			<div class="col-12 p-0 flex">
				<div class="col p-0">
					<div class="col-12 py-0">
						<span>{{popUpComponent.popUpTitle}}</span>
					</div>
					<div class="col-12 py-0">
						<span>Plates count: {{mappedRedoPlates.length}}</span>
					</div>
				</div>
				<div class="col p-0">
					<div class="col-12 py-0 w-auto flex my-1 justify-content-center">
						<button pButton [label]="dialogHeader" class="min-w-min w-10rem h-2rem md:text-sm px-0 text-white div-button-active stop-action-button" (click)="updateMultiplePlates()"></button>
					</div>
				</div>
				<div class="col-1"></div>
			</div>
			<div class="col-12 flex justify-content-between m-0">
				<div *ngFor="let scan of popUpComponent.scans; let scanIndex=index;" class="h-1rem md:text-sm text-primary col text-center font-bold"> {{scan.scanType=='MACHINE'?scan.scanType: scan.plateType}} </div>
				<div class="h-1rem md:text-sm text-primary col text-center font-bold">Redo Selection</div>
				<div class="col-1"></div>
			</div>
			<div class="col-12 flex justify-content-between m-0">
				<div *ngFor="let scan of popUpComponent.scans; let scanIndex=index;" class="md:text-sm text-primary col">
					<input pInputText class="h-2rem w-full" name="plateId" id="popUpDialog-scan-{{scanIndex}}" [(ngModel)]="popUpScanInputValues[scanIndex]" (keydown.enter)="validateScan(scanIndex, popUpScanInputValues[scanIndex], scan.plateType)" placeholder="{{scan.scanName}}" [disabled]="isRedoFromHistory" />
				</div>
				<div class="md:text-sm text-primary col">
					<p-dropdown #redoSelectorDropdown [filter]="true" filterBy="label" optionLabel="label" optionValue="value" [options]="redoOptions" placeholder="Select Redo Type" appendTo="body" [(ngModel)]="selectedRedoType" [style]="{'width':'100%'}" styleClass="h-2rem" [disabled]="isRedoFromHistory"></p-dropdown>
				</div>
				<div class="col-1"></div>
			</div>
			<div class="plate-scan-values">
				<ng-container *ngFor="let redoPlateInformation of mappedRedoPlates; let index = index;">
					<div class="col-12 grid justify-content-between m-0 py-1"
						*ngIf="redoPlateInformation.sourcePlateInformations.length > 0; else nonMergePlateQC">
						<div class="col-12 flex p-0">
							<div class="col-11 text-lg" style="font-weight: 800;"> {{ redoPlateInformation.currentPlateID }} - Merge
							</div>
							<div class="col-1 py-0">
								<button pButton icon="pi pi-times" class="p-button-danger p-1 text-sm"
									(click)="deleteScanValues(index, redoPlateInformation)"></button>
							</div>
						</div>
						<ng-container *ngFor="let redoSourcePlateInformation of redoPlateInformation.sourcePlateInformations">
							<div class="col-12 grid justify-content-between m-0 py-0"
								*ngIf="redoSourcePlateInformation.sourcePlates.length > 0; else merge2ndLevelPlateQC">
								<div class="col-12 text-lg" style="font-weight: 600;">{{ redoSourcePlateInformation.sourcePlateID }}
									-
									Merge</div>
								<div class="col-12 grid">
									<ng-container *ngFor="let sourcePlate of redoSourcePlateInformation.sourcePlates">
										<div class="col-12 flex m-1 pb-0 pt-1">
											<div class="text-lg col m-0 py-0" style="font-weight: 300;">
												{{ sourcePlate }}
											</div>
											<div class="col m-0 py-0"
												*ngIf="redoSelectionMap[sourcePlate]==''; else selectedRedoOption">
												<p-dropdown [filter]="true" filterBy="label" optionLabel="label" optionValue="value"
													[options]="redoOptions" placeholder="Select Redo Type" appendTo="body"
													[(ngModel)]="redoSelectionMap[sourcePlate]" [style]="{'width':'100%'}"
													styleClass="h-2rem"></p-dropdown>
											</div>
											<ng-template #selectedRedoOption>
												<div class="text-primary text-lg col py-0">
													{{ redoSelectionMap[sourcePlate] }}
												</div>
											</ng-template>
											<div class="col-1 py-0"></div>
										</div>
									</ng-container>
								</div>
								<div class="col-1 py-0"></div>
							</div>
							<ng-template #merge2ndLevelPlateQC>
								<div class="col-12 flex m-0 pb-0 pt-0 py-2">
									<div class="col m-0 py-0 text-lg" style="font-weight: 600;">{{
										redoSourcePlateInformation.sourcePlateID
										}}</div>
									<div class="col m-0 py-0"
										*ngIf="redoSelectionMap[redoSourcePlateInformation.sourcePlateID]==''; else selectedRedoOption">
										<p-dropdown [filter]="true" filterBy="label" optionLabel="label" optionValue="value"
											[options]="redoOptions" placeholder="Select Redo Type" appendTo="body"
											[(ngModel)]="redoSelectionMap[redoSourcePlateInformation.sourcePlateID]"
											[style]="{'width':'95%'}" styleClass="h-2rem"></p-dropdown>
									</div>
									<ng-template #selectedRedoOption>
										<div class="text-primary text-bold text-lg col py-0">
											{{ redoSelectionMap[redoSourcePlateInformation.sourcePlateID] }}
										</div>
									</ng-template>
									<div class="col-1 py-0"></div>
								</div>
							</ng-template>
						</ng-container>
					</div>
					<ng-template #nonMergePlateQC>
						<div class="col-12 flex m-0 pb-0 pt-1">
							<div class="text-primary text-lg col py-0" style="font-weight: 650;">
								{{ redoPlateInformation.currentPlateID }}
							</div>
							<div class="col m-0 py-0"
								*ngIf="redoSelectionMap[redoPlateInformation.currentPlateID]==''; else selectedRedoOption">
								<p-dropdown [filter]="true" filterBy="label" optionLabel="label" optionValue="value"
									[options]="redoOptions" placeholder="Select Redo Type" appendTo="body"
									[(ngModel)]="redoSelectionMap[redoPlateInformation.currentPlateID]" [style]="{'width':'100%'}"
									styleClass="h-2rem"></p-dropdown>
							</div>
							<ng-template #selectedRedoOption>
								<div class="text-primary text-bold text-lg col py-0">
									{{ redoSelectionMap[redoPlateInformation.currentPlateID] }}
								</div>
							</ng-template>
							<div class="col-1 py-0">
								<button pButton icon="pi pi-times" class="p-button-danger p-1 text-sm"
									(click)="deleteScanValues(index, redoPlateInformation)"></button>
							</div>
						</div>
					</ng-template>
				</ng-container>
			</div>
		</div>
	</div>
</div>